import { IsEmptyString } from "../../Components/GeneralFunctions.jsx"

export function ZendeskGetAutoExecuteOnState() {
    return localStorage.getItem("zendesk_setting_autoexecuteonstate") ?? ""
}

export function ZendeskGetAutoActionNoMatch() {
    return localStorage.getItem("zendesk_setting_autoactionnomatch")
}

export function ZendeskGetAutoActionOneMatch() {
    let settingautoactiononematch = localStorage.getItem("zendesk_setting_autoactiononematch")
    if (settingautoactiononematch == null)
    {
        //if there is no zendesk_setting_autoactiononematch setting, try to read it from the 
        const settingshowmatch = localStorage.getItem("zendesk_setting_showmatch") === "1"
        const settingshowopenticket = localStorage.getItem("zendesk_setting_showopenticket") === "1"
        const settingcreatenewticket = localStorage.getItem("zendesk_setting_createnewticket") === "1"
        settingautoactiononematch = !settingshowmatch && !settingshowopenticket && !settingcreatenewticket ? "" :
            (settingshowmatch && !settingshowopenticket && !settingcreatenewticket ? "showuser" : 
                (settingshowopenticket && !settingcreatenewticket ? "showopenticket" :
                    (settingshowopenticket && settingcreatenewticket ? "smarthandling" : "createandshowticket")
                )
            )
        localStorage.setItem("zendesk_setting_autoactiononematch", settingautoactiononematch)
    }
    return settingautoactiononematch
}

export function ZendeskGetTicketInboundCallBody() {
    let Result = localStorage.getItem("zendesk_setting_ticketinboundcallbody")
    if (IsEmptyString(Result))
    {
        Result = "Call info: \r\nCall from: <name> + \r\nPhone number: <number> \r\nCalled number: <ddi>\r\nStarted: <callstart> \r\nCall duration: <calltime>"
    }
    return Result
}

export function ZendeskGetTicketInboundCallSubject() {
    let Result = localStorage.getItem("zendesk_setting_ticketinboundcallsubject")
    if (IsEmptyString(Result))
    {
        Result = "Inbound call"
    }
    return Result
}

export function ZendeskGetTicketOutboundCallBody() {
    let Result = localStorage.getItem("zendesk_setting_ticketoutboundcallbody")
    if (IsEmptyString(Result))
    {
        Result = "Call info: \r\nCall to: <name> + \r\nPhone number: <number>\r\nStarted: <callstart> \r\nCall duration: <calltime>"
    }
    return Result
}

export function ZendeskGetTicketOutboundCallSubject() {
    let Result = localStorage.getItem("zendesk_setting_ticketoutboundcallsubject")
    if (IsEmptyString(Result))
    {
        Result = "Outbound call"
    }
    return Result
}

export function ZendeskGetTicketInboundCallBrandPerDdi() {
    return localStorage.getItem("zendesk_setting_ticketinboundcallbrandperddi") ?? ""
}

export function ZendeskGetTicketInboundCallGroupPerDdi() {
    return localStorage.getItem("zendesk_setting_ticketinboundcallgroupperddi") ?? ""
}

export function ZendeskGetTicketInboundCallTagPerDdi() {
    return localStorage.getItem("zendesk_setting_ticketinboundcalltagperddi") ?? ""
}

export function ZendeskGetTicketOutboundCallTag() {
    return localStorage.getItem("zendesk_setting_ticketoutboundcalltag") ?? ""
}

export function ZendeskSetAutoActionNoMatch(value) {
    localStorage.setItem("zendesk_setting_autoactionnomatch", value)
}

export function ZendeskSetAutoActionOneMatch(value) {
    localStorage.setItem("zendesk_setting_autoactiononematch", value)
}

export function ZendeskSetAutoExecuteOnState(value) {
    localStorage.setItem("zendesk_setting_autoexecuteonstate", value)
}

export function ZendeskSetTicketInboundCallBody(value) {
    localStorage.setItem("zendesk_setting_ticketinboundcallbody", value)
}

export function ZendeskSetTicketInboundCallSubject(value) {
    localStorage.setItem("zendesk_setting_ticketinboundcallsubject", value)
}

export function ZendeskSetTicketOutboundCallBody(value) {
    localStorage.setItem("zendesk_setting_ticketoutboundcallbody", value)
}

export function ZendeskSetTicketOutboundCallSubject(value) {
    localStorage.setItem("zendesk_setting_ticketoutboundcallsubject", value)
}

export function ZendeskSetTicketInboundCallBrandPerDdi(value) {
    localStorage.setItem("zendesk_setting_ticketinboundcallbrandperddi", value)
}

export function ZendeskSetTicketInboundCallGroupPerDdi(value) {
    localStorage.setItem("zendesk_setting_ticketinboundcallgroupperddi", value)
}

export function ZendeskSetTicketInboundCallTagPerDdi(value) {
    localStorage.setItem("zendesk_setting_ticketinboundcalltagperddi", value)
}

export function ZendeskSetTicketOutboundCallTag(value) {
    localStorage.setItem("zendesk_setting_ticketoutboundcalltag", value)
}